// Razorpay Configuration
// Replace these values with your actual Razorpay credentials

export const RAZORPAY_CONFIG = {
  // Test Key - Replace with your actual Razorpay Key ID
  keyId: "rzp_test_R6sPjN4prs5Uzb",
  
  // Production Key - Uncomment and use for production
  // keyId: "rzp_live_your_live_key_here",
  
  // Currency
  currency: "INR",
  
  // Company details
  company: {
    name: "Pathshala Sanchalak",
    logo: "/assets/img/logo.png", // Path to your company logo
    description: "Educational Platform"
  },
  
  // Theme colors
  theme: {
    color: "#1f88d4" // Primary brand color
  },
  
  // Payment methods to show
  paymentMethods: {
    card: true,
    netbanking: true,
    wallet: true,
    upi: true,
    emi: false
  }
};

// Helper function to format amount for Razorpay (convert to paise)
export const formatAmountForRazorpay = (amount: number): number => {
  return Math.round(amount * 100); // Convert rupees to paise
};

// Helper function to format amount for display
export const formatAmountForDisplay = (amount: number, currency: string = "INR"): string => {
  return new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).format(amount);
};

export default RAZORPAY_CONFIG;
